import { useState, ReactElement, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from '../locales/messages';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';
import {
  estInspectionTableData,
  estMaintenanceTableData,
} from '../constants/default';

export interface thanksProps {
  usersAmount: number;
  envCount: number;
  concurrentAmount: number;
  authorizedAmount: number;
  healthScoresAmount: number;
  tileValue: string;
  licensePriceMonthly: string;
  packageName: string;
  bpName: string;
  onInspection: boolean;
  appPoints: number;
}

const Thanks = ({
  usersAmount,
  envCount,
  concurrentAmount,
  authorizedAmount,
  healthScoresAmount,
  tileValue,
  licensePriceMonthly,
  packageName,
  bpName,
  onInspection,
  appPoints,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const [, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    { group: 'title', value: intl.formatMessage(messages.thank_you) },
    {
      group: 'subTitle',
      value: intl.formatMessage(messages.received_text),
    },
  ];

  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: intl.formatMessage(messages.req_detail),
    },
  ];

  const essentialsMaintenanceInfo: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages.package_label)),
      value: packageName,
    },
    {
      group: String(intl.formatMessage(messages.user_text)),
      value: String(usersAmount),
    },
    {
      group: String(intl.formatMessage(messages.env_text)),
      value: String(envCount),
    },
    {
      group: String(intl.formatMessage(messages.work_order_text)),
      value: String(estMaintenanceTableData.workOrdersHour),
    },
    {
      group: String(intl.formatMessage(messages.health_score_text)),
      value: String(estMaintenanceTableData.healthScoresrHour),
    },
    {
      group: String(intl.formatMessage(messages.estimated_text)),
      value: String(licensePriceMonthly),
    },
  ];

  const essentialsInspectionInfo: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages.package_label)),
      value: packageName,
    },
    {
      group: String(intl.formatMessage(messages.client_device_text)),
      value: String(estInspectionTableData.clientDevice),
    },
    {
      group: String(intl.formatMessage(messages.inference_text)),
      value: String(estInspectionTableData.inferencesHour),
    },
    {
      group: String(intl.formatMessage(messages.storage_text)),
      value: String(estInspectionTableData.storage),
    },
    {
      group: String(intl.formatMessage(messages.estimated_text)),
      value: String(licensePriceMonthly),
    },
  ];

  const essentialsInfo = !onInspection
    ? essentialsMaintenanceInfo
    : essentialsInspectionInfo;

  const standardInfo: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages.package_label)),
      value: packageName,
    },
    {
      group: String(intl.formatMessage(messages.concurrent_user)),
      value: String(concurrentAmount),
    },
    {
      group: String(intl.formatMessage(messages.authorized_user)),
      value: String(authorizedAmount),
    },
    {
      group: String(intl.formatMessage(messages.health_score_text)),
      value: String(healthScoresAmount),
    },
    {
      group: String(intl.formatMessage(messages.appPoints_text)),
      value: String(appPoints),
    },
    {
      group: String(intl.formatMessage(messages.estimated_text)),
      value: String(licensePriceMonthly),
    },
  ];

  const contentThanks =
    tileValue === 'essentials' ? essentialsInfo : standardInfo;

  bpName &&
    contentThanks.push({
      group: String(intl.formatMessage(messages.bp_title)),
      value: bpName,
    });

  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages.return_est_text)),
    },
  ];

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, [
    usersAmount,
    envCount,
    concurrentAmount,
    onInspection,
    authorizedAmount,
    healthScoresAmount,
  ]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="MAS SaaS Pricing Page"
      object="Pricing Page"
      productTitle={'MAS SaaS Price Estimator'}
      pageUrl={'/products/maximo/pricing/'}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    />
  );
};

export default Thanks;
